<template lang="pug">
#app
  #game-container(ref="container")
  router-view
  //- landscape-warning
  desktop
  web-gl
  debug(v-if="debug")

  .fonts
    p.tradegothic abcdefghijklmnopqrstuvwxyz
    p.digital 0123456789
    p.cjnbold {{ flatMessages }}
    p.fos {{ flatMessages }}PEGASUS
</template>

<script>
const THREE = require('three')

import {mapState, mapMutations, mapActions} from 'vuex'
import LandscapeWarning from '@/components/landscape-warning/LandscapeWarning'
import Desktop from '@/components/unsupported/Desktop'
import WebGl from '@/components/unsupported/WebGl'
import Debug from '@/components/debug/Debug'
import game from '@/components/game/main.js'
window.game = game

import flatMessages from 'src/../build/fontSubsetData'

export default {
  name: 'app',
  components: {
    LandscapeWarning,
    Desktop,
    WebGl,
    Debug
  },
  data () {
    return {
      flatMessages: flatMessages
    }
  },
  computed: {
    ...mapState('game', ['debug'])
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
    window.addEventListener('orientationchange', this.onOrientationChange)
    this.init()

    // this.getCountry()
  },
  methods: {
    init () {
      let container = this.$refs.container
      while (container.firstChild) {
        container.removeChild(container.firstChild)
      }
      container.appendChild(game.renderer.renderer.domElement)
    },
    onResize () {
      // this.$store.commit('resize', {width: window.innerWidth, height: window.innerHeight})
      this.resize({width: window.innerWidth, height: window.innerHeight})
    },
    onOrientationChange () {
      // this.$store.commit('resize', {width: window.innerWidth, height: window.innerHeight})
      this.resize({width: window.innerWidth, height: window.innerHeight})
    },
    ...mapActions('browser', [
      'getCountry'
    ]),
    ...mapMutations('browser', [
      'resize'
    ])
  }
}
</script>

<style lang="sass">
@import "src/common.sass"

html
  font-family: $font
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale

html, body
  +full()
  position: fixed
  margin: 0
  font-size: 0.9em
  text-transform: uppercase

*, *:before, *:after
  box-sizing: border-box

a
  text-decoration: none
  color: inherit

ul, li
  margin: 0
  padding: 0
  list-style: none

h1, h2, h3, h4, p
  margin: 0

button, input
  border: none
  outline: none
  appearance: none
  font-family: $font
  font-size: 1rem
  padding: 0
  text-transform: uppercase

button
  cursor: pointer
  -webkit-tap-highlight-color: transparent
  background: none

#app
  +full()

.fonts
  z-index: -10
  // position: absolute
  // top: 0
  // left: 0
  // z-index: 10000
  pointer-events: none
  color: white

  // .tradegothic
  //   font-family: 'TradeGothicLTStd'
  .digital
    font-family: 'digital'
  // .cjnbold
  //   font-family: 'cjnbold'
  .fos
    font-family: 'FoS'

</style>



// WEBPACK FOOTER //
// App.vue?38404c7b